export default __webpack_public_path__ + "static/outlet_w.0f44df59f60ac03bb0a4531f587cc09e.png";